<template>
    <div >
        <banner     v-model:is-open="$data._openBanner"
                    :auto-hide="autoHide"
                    bg-color="bg-red-50"
                    fg-color="text-red-700">
            <template #icon>
                <!-- Heroicon name: x-circle -->
                <svg class="h-5 w-5 text-red-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
                </svg>
            </template>

            <template #title>
                <slot name="title">(Default) Error Found</slot></template>

            <template #content>
                <slot name="content">
                    <p><b>(Default)</b> Action required, please act.</p>
                </slot>
            </template>
        </banner>
    </div>
</template>

<script>
import Banner from "@/components/Banners/Banner"

export default {
    name: "BannerError",
    mixins: [],
    components: { Banner },
    props: {
        isOpen: {
            type: Boolean,
            default: true,
        },
        autoHide: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {
            _openBanner: this.isOpen,
        }
    },
    mounted() {

    },
    methods: {
    
    },
    watch: {
        isOpen(val, old) {
            if (val !== old) {
                this.$data._openBanner = this.isOpen
            }
        },
        _openBanner(val, old) {
            if (val !== old && this.$data._openBanner !== this.isOpen) {
                this.$emit('update:isOpen', this.$data._openBanner)
            }
        },
    },
    computed: {
    
    },
}
</script>